import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, filter, map } from 'rxjs';

@Pipe({
  name: 'isControlInvalid',
  standalone: true,
})
export class IsControlInvalidPipe implements PipeTransform {
  transform(control: FormControl): Observable<boolean> {
    return control.valueChanges.pipe(
      filter((val) => !!val),
      map(() => control.errors != null && (control.dirty || control.touched)),
    );
  }
}
